<template>
  <div>
    <InfoBanner page="invest" />
    <div class="invest container">
      <div class="row">
        <div class="col-lg-12">
          <loader v-show="isLoading" />
          <div v-if="!isLoading" class="container invest-section">
            <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                :class="[
                  tableStep !== 2 ? 'col-xl-8 col-lg-8' : 'col-xl-12 col-lg-12',
                ]"
              >
                <before-form-header
                  class="header-table over-header"
                  :title="$t('views.invest.invest')"
                  description=""
                />
                <div class="row bottom-stepper">
                  <div class="col-12">
                    <b-tabs
                      navWrapperClass="income-tabs"
                      pills=""
                      class="w-100 income-tabs-list"
                    >
                      <b-tab
                        v-for="i in tableSteps"
                        :key="'tab-' + i.id"
                        :title="$t(i.title)"
                        :active="i.id === tableStep"
                        @click="setTableStep(i.id)"
                      ></b-tab>
                    </b-tabs>
                  </div>
                </div>
                <template v-if="tableStep === 1">
                  <div class="income-box">
                    <p class="description">
                      <strong>{{ $t("views.invest.useSavedFilters") }}</strong>
                    </p>
                    <b-button
                      class="btn btn-sm blue-filter"
                      v-b-toggle.sidebar-1
                      >Filters</b-button
                    >
                    <b-sidebar
                      id="sidebar-1"
                      class="sdb"
                      title="Filters"
                      shadow
                    >
                      <template #header="{ hide }">
                        <div>
                          <strong id="sidebar-filters___title__"
                            >Filters</strong
                          >
                          <div class="right">
                            <button
                              type="button"
                              aria-label="Close"
                              class="close text-dark"
                              @click="hide"
                            >
                              <svg
                                viewBox="0 0 16 16"
                                width="1em"
                                height="1em"
                                focusable="false"
                                role="img"
                                aria-label="x"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                class="bi-x b-icon bi"
                              >
                                <g>
                                  <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                                  ></path>
                                </g>
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div>
                          <search @setSearch="setSearch"></search>
                          <div class="top-row">
                            <div
                              v-show="showPotentialCount"
                              class="text-left potential-count"
                            >
                              {{ $t("views.invest.potentialLoans")
                              }}<span class="count">{{
                                potentialResultsCount !== "-"
                                  ? potentialResultsCount
                                  : ""
                              }}</span>
                              <square-loader
                                v-if="potentialResultsCount === '-'"
                              ></square-loader>
                            </div>
                            <div
                              class="text-right top-btns reset-filter"
                              v-show="enabledFilters.length"
                            >
                              <b-button
                                class="clear-filter"
                                @click="resetFilters"
                                ><img
                                  src="../assets/clear_filters.svg"
                                  alt=""
                                />{{
                                  $t("views.invest.resetFilters")
                                }}</b-button
                              >
                            </div>
                          </div>
                          <div
                            class="set-filter-block"
                            v-show="enabledFilters.length || showPotentialCount"
                          >
                            <b-button
                              class="btn apply-filter"
                              @click="applyFilters"
                              >{{ $t("views.invest.applyFilters") }}</b-button
                            >
                            <b-button
                              class="btn set-favorite-filter"
                              v-b-modal.modal-prevent-closing
                              >{{
                                $t("views.invest.setFilterAsFavourite")
                              }}</b-button
                            >
                            <b-button
                              class="btn create-strategy"
                              to="/strategy/create?use-filters=1"
                              @click="scrollToTop"
                              >{{
                                $t("views.invest.createAutoinvestStrategy")
                              }}</b-button
                            >
                          </div>
                        </div>
                      </template>
                      <div class="right-filters" v-if="showFilters">
                        <div
                          v-for="filter in this.showFilters"
                          v-bind:key="filter.id"
                        >
                          <filter-block
                            v-if="!filter.advanced"
                            :filter="filter"
                            :default-value="getDefaultFilterValue(filter)"
                            :default-display="
                              getDefaultFilterValue(filter) ? true : null
                            "
                            :custom-filter="customFilter"
                            :use-enabled-filters="true"
                            @set-filter="setFilter"
                          ></filter-block>
                        </div>
                        <div>
                          <b-button
                            v-b-toggle.advanced-collapse
                            variant="outline-primary"
                            class="advancedBtn"
                            >{{ $t("filters.advanced") }}
                            <span v-if="advancedShow">❮</span>
                            <span v-if="!advancedShow">❯</span></b-button
                          >
                          <b-collapse
                            :visible="advancedShow"
                            id="advanced-collapse"
                          >
                            <div
                              v-for="filter in this.showFilters"
                              v-bind:key="'advanced_' + filter.id"
                            >
                              <filter-block
                                v-if="filter.advanced"
                                :filter="filter"
                                :default-value="getDefaultFilterValue(filter)"
                                :default-display="
                                  getDefaultFilterValue(filter) ? true : null
                                "
                                :custom-filter="customFilter"
                                :use-enabled-filters="true"
                                @set-filter="setFilter"
                              ></filter-block>
                            </div>
                          </b-collapse>
                        </div>
                        <b-modal
                          id="modal-prevent-closing"
                          ref="modal"
                          :title="$t('views.invest.filterSettings')"
                          @show="resetModal"
                          @hidden="resetModal"
                          @ok="handleOk"
                        >
                          <form ref="form" @submit.stop.prevent="handleSubmit">
                            <b-form-group
                              :state="filterNameState"
                              :label="$t('views.invest.filterName')"
                              label-for="name-input"
                              invalid-feedback="Filter name is required"
                              autofocus
                            >
                              <b-form-input
                                id="name-input"
                                v-model="filterName"
                                :state="filterNameState"
                                required
                              ></b-form-input>
                            </b-form-group>
                          </form>
                        </b-modal>
                        <div class="bottom-note">
                          {{ $t("views.invest.allLoansCome") }}
                        </div>
                      </div>
                    </b-sidebar>
                  </div>
                  <div class="income-box">
                    <b-table
                      hover
                      ref="invest"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :items="loadInvestData"
                      :busy="isTableItemsLoading"
                      :fields="tableFields"
                      class="invest-table income-table"
                      thead-class="hidden_header"
                      responsive
                    >
                      <template #table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{
                            width: field.key === 'invest' ? '1200px' : '180px',
                          }"
                        />
                      </template>
                      <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                          <loader></loader>
                        </div>
                      </template>
                      <template v-slot:head()="data">
                        <span class="table-header">{{ $t(data.label) }}</span>
                      </template>
                      <template v-slot:cell(id)="{ item }">
                        <router-link :to="{ path: '/loan/' + item.loan_ref }"
                          >{{ item.loan_ref }} <br />
                          {{ item.loan_type }}</router-link
                        >
                      </template>
                      <template v-slot:cell(originator)="{ item }">
                        <a
                          :href="
                            loanOriginatorPageUrl(
                              item.loan_originator_name,
                              item.loan_originator_page_url
                            )
                          "
                          target="_blank"
                          >{{ item.loan_originator_name }}</a
                        >
                        <!--                  / {{ item.originator_rating }}-->
                      </template>
                      <template v-slot:cell(country)="{ value }">
                        <img class="flag" :src="getFlag(value)" alt="" />
                      </template>
                      <template v-slot:head(investable_amount)="data">
                        <span class="text-right table-header">{{
                          $t(data.label)
                        }}</span>
                      </template>
                      <!--                    <template v-slot:head(invest)="data">-->
                      <!--                      <div class="invest-section">123{{ $t(data.label) }}</div>-->
                      <!--                    </template>-->
                      <template v-slot:cell(investable_amount)="{ value }">
                        <div class="text-right">
                          {{ value | moneyFormatter }}
                        </div>
                      </template>
                      <template v-slot:head(loan_currency)="data">
                        <div class="text-right table-header">
                          <help-tooltip
                            style="width: 14px"
                            :tooltipText="
                              $t('views.invest.tooltipLoanCurrency')
                            "
                          />
                          {{ $t(data.label) }}
                        </div>
                      </template>
                      <template v-slot:head(loan_issued_amount_in_eur)="data">
                        <div class="text-right table-header">
                          <help-tooltip
                            style="width: 14px"
                            :tooltipText="
                              $t('views.invest.tooltipLoanIsIssued')
                            "
                          />
                          {{ $t(data.label) }}
                        </div>
                      </template>
                      <template
                        v-slot:cell(loan_issued_amount_in_eur)="{ item }"
                      >
                        <div class="text-right">
                          {{ item.loan_issued_amount_in_eur | moneyFormatter }}
                        </div>
                      </template>
                      <template
                        v-slot:cell(loan_investor_interest_rate)="{ value }"
                      >
                        {{ value }}
                      </template>
                      <template v-slot:cell(loan_due_date)="{ item }">
                        {{
                          showDiffInTermFormat(
                            item.loan_due_date,
                            new Date().toDateString()
                          )
                        }}
                      </template>
                      <template v-slot:cell(loan_status)="{ item }">
                        <div class="">{{ $t(item.loan_status_i18n) }}</div>
                      </template>
                      <template v-slot:cell(loan_buyback_date)="{ item }">
                        {{
                          showDiffInTermFormat(
                            item.loan_buyback_date,
                            new Date().toDateString()
                          )
                        }}
                      </template>
                      <template v-slot:cell(invest)="row">
                        <div class="invest-section">
                          <b-button
                            size="sm"
                            v-model="displayInvest[row.item.loan_ref]"
                            class="invest-btn"
                            variant="light"
                            v-show="showInvestButton(row.item.loan_ref)"
                            @click="showInvestInput(row.item.loan_ref)"
                            v-b-tooltip.hover
                            :title="$t('views.invest.clickHereToInvest')"
                            >{{ $t("views.invest.invest1") }}
                          </b-button>
                          <div class="w-100 text-center">
                            <div
                              class="invest-form"
                              v-show="!showInvestButton(row.item.loan_ref)"
                            >
                              <b-input-group size="sm" class="invest-ig">
                                <b-input-group-prepend class="prepend">
                                  €
                                </b-input-group-prepend>
                                <b-form-input
                                  @input="
                                    validate(
                                      $event,
                                      row.item.loan_ref,
                                      row.item.investable_amount
                                    )
                                  "
                                  v-bind:ref="row.item.loan_ref"
                                  type="number"
                                  step="any"
                                  v-bind:min="
                                    getMinAmount(row.item.investable_amount)
                                  "
                                  v-bind:max="
                                    parseFloat(row.item.investable_amount)
                                  "
                                  class="invest-input"
                                  @change="
                                    maxRound(
                                      $event,
                                      row.item.investable_amount,
                                      row.item.loan_ref
                                    )
                                  "
                                  @keypress="isNumber($event)"
                                  v-on:keyup.enter="addInvest(row.item)"
                                ></b-form-input>
                                <b-input-group-append
                                  class="append"
                                  @click="addInvest(row.item)"
                                  v-b-tooltip.hover.right="
                                    $t('views.invest.clickHereToMakeInvestment')
                                  "
                                >
                                  <img
                                    v-bind:src="getSrc('portfolio.svg')"
                                    alt=""
                                  />
                                </b-input-group-append>
                              </b-input-group>
                              <b-input-group-text
                                class="remove-invest"
                                @click="removeDisplayInvest(row.item.loan_ref)"
                              >
                                <b-icon icon="x" />
                              </b-input-group-text>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-slot:cell(show_details)="row">
                        <b-button
                          size="sm"
                          ref="telInputWrapper"
                          @click="row.toggleDetails"
                          class="toggle-details-btn"
                          variant="light"
                        >
                          {{ row.detailsShowing ? "&#x25B2;" : "&#x25BC;" }}
                        </b-button>

                        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                        <b-form-checkbox
                          v-model="row.detailsShowing"
                          @change="row.toggleDetails"
                          class="d-none"
                          >{{
                            $t("views.invest.detailsViaCheck")
                          }}</b-form-checkbox
                        >
                      </template>
                      <template v-slot:row-details="row">
                        <b-card>
                          <b-row class="mb-2">
                            <b-col sm="2" class="text-sm-right"
                              ><b>{{ $t("views.invest.listingDate") }}</b
                              ><br />
                              {{
                                showDateInDotFormat(row.item.loan_list_datetime)
                              }}</b-col
                            >
                            <b-col sm="2" class="text-sm-right"
                              ><b>{{ $t("views.invest.loanCurrency") }}</b
                              ><br />
                              {{ row.item.loan_currency }}</b-col
                            >
                            <b-col sm="2" class="text-sm-right"
                              ><b>{{ $t("views.invest.loanAmountIn") }}</b
                              ><br />
                              {{
                                row.item.loan_issued_amount
                                  | moneyFormatterWithCurrency(
                                    row.item.loan_currency
                                  )
                              }}
                            </b-col>
                            <b-col sm="2" class="text-sm-right"
                              ><b>{{ $t("views.invest.buyback") }}</b
                              ><br />
                              {{
                                row.item.loan_buyback_guarantee === 1
                                  ? $t("views.investments.yes")
                                  : $t("views.investments.no")
                              }}
                            </b-col>
                            <b-col sm="2" class="text-sm-right"
                              ><b>{{ $t("views.invest.remainingTerm") }}</b
                              ><br />
                              {{
                                showDiffInTermFormat(
                                  row.item.loan_due_date,
                                  new Date()
                                )
                              }}</b-col
                            >
                          </b-row>
                          <b-button
                            class="d-none"
                            size="sm"
                            @click="row.toggleDetails"
                            >{{ $t("views.invest.hideDetails") }}</b-button
                          >
                          <b-button
                            class="loan-details"
                            size="sm"
                            @click="$router.push('/loan/' + row.item.loan_ref)"
                            >{{ $t("views.invest.openLoanDetails") }}</b-button
                          >
                        </b-card>
                      </template>
                    </b-table>
                    <div>
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                      ></b-pagination>
                    </div>
                  </div>
                  <b-modal
                    ref="next-step"
                    size="sm"
                    hide-footer
                    :title="$t('views.invest.addedWhatNext')"
                    class="modal-fix"
                  >
                    <b-button
                      class="mt-3 confirm-btn"
                      block
                      @click="$router.push({ path: '/confirm-investment' })"
                      >{{ $t("views.invest.confirmInvestment") }}</b-button
                    >
                    <b-button class="mt-3 invest" block @click="hideModal">{{
                      $t("views.invest.continueBrowsingLoans")
                    }}</b-button>
                    <b-button
                      class="mt-2 continue"
                      block
                      @click="$router.push({ path: '/investments' })"
                      >{{ $t("views.invest.myInvestments") }}</b-button
                    >
                  </b-modal>
                </template>
                <template v-if="tableStep === 2">
                  <div class="income-box">
                    <p class="description">
                      {{ $t("views.invest.automateYourInvestments") }}
                    </p>
                    <div>
                      <div class="invest-stat-top" style="margin-bottom: 16px">
                        <div class="flex-1 center" style="padding: 6px">
                          <div class="title" style="margin-right: 10px">
                            {{
                              $t(
                                "views.invest.yourAutomatedInvestmentStrategies"
                              )
                            }}
                          </div>
                          <div class="value text-right">
                            {{ totalPortfolioSize | moneyFormatter }}
                          </div>
                        </div>
                        <div class="text-right create flex-1">
                          <b-button variant="primary" to="/strategy/create">{{
                            $t("views.invest.createNewStrategy")
                          }}</b-button>
                        </div>
                      </div>
                      <loader v-show="isStrategyListLoading" />
                      <div class="overview" v-if="!isStrategyListLoading">
                        <template v-for="row in strategies">
                          <div class="row" v-bind:key="row.id">
                            <div
                              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                            >
                              <div class="your">
                                <div class="info-table">
                                  <div class="row">
                                    <div
                                      class="col-md-5 col-lg-5 col-xl-5 col-sm-12 left-side"
                                    >
                                      <div class="center">
                                        <div class="header0 flex-1">
                                          {{ row.name }}
                                        </div>
                                        <div>
                                          {{
                                            row.active
                                              ? $t("views.invest.active")
                                              : $t("views.invest.inactive")
                                          }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{
                                            $t("views.invest.earnedInterest")
                                          }}
                                        </div>
                                        <div class="col-6 text-right">
                                          {{
                                            row.earned_interest | moneyFormatter
                                          }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{
                                            $t(
                                              "views.invest.investedFundsTotal"
                                            )
                                          }}
                                          <help-tooltip
                                            :tooltipText="'views.invest.investedFundsTotalHelp'"
                                          ></help-tooltip>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{
                                            row.invested_funds_total
                                              | moneyFormatter
                                          }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{
                                            $t(
                                              "views.invest.investedFundsCurrent"
                                            )
                                          }}
                                          <help-tooltip
                                            :tooltipText="'views.invest.investedFundsCurrentHelp'"
                                          ></help-tooltip>
                                        </div>
                                        <div class="col-6 text-right">
                                          {{
                                            row.invested_funds | moneyFormatter
                                          }}
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{ $t("views.invest.reinvestFunds") }}
                                        </div>
                                        <div class="col-6 text-right">
                                          <img
                                            :src="
                                              getSrc(
                                                'elements/' +
                                                  (row.reinvest_funds
                                                    ? 'true.svg'
                                                    : 'false.svg')
                                              )
                                            "
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{ $t("views.invest.diversify") }}
                                          <help-tooltip
                                            :tooltipText="'views.invest.diversifyHelp'"
                                          ></help-tooltip>
                                        </div>
                                        <div class="col-6 text-right">
                                          <img
                                            :src="
                                              getSrc(
                                                'elements/' +
                                                  (row.diversify
                                                    ? 'true.svg'
                                                    : 'false.svg')
                                              )
                                            "
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-6">
                                          {{ $t("views.invest.loans") }}
                                        </div>
                                        <div class="col-6 text-right">
                                          {{ row.loans_count }}
                                          <span
                                            v-if="row.loans_count"
                                            class="small"
                                          >
                                            <br />
                                            (<b-link
                                              :to="
                                                'investments?strategy_id=' +
                                                row.id
                                              "
                                              >{{
                                                $t(
                                                  "views.invest.viewInvestedLoans"
                                                )
                                              }}</b-link
                                            >)
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        class="row"
                                        v-if="row.last_run_result"
                                      >
                                        <div class="col-6">
                                          {{ $t("views.invest.lastRunResult") }}
                                        </div>
                                        <div class="col-6 text-right">
                                          {{
                                            $t(
                                              "views.invest.autoinvestlog.messages." +
                                                row.last_run_result_i18n
                                            )
                                          }}
                                        </div>
                                      </div>
                                      <div
                                        class="row"
                                        v-if="
                                          row.minutes_from_last_run !== null
                                        "
                                      >
                                        <div class="col-6">
                                          {{
                                            $t("views.invest.lastRunMinutes")
                                          }}
                                        </div>
                                        <div class="col-6 text-right">
                                          {{ row.minutes_from_last_run }}
                                          <span class="small">
                                            <br />
                                            (<b-link
                                              @click="
                                                loadRecentAutoinvestJobs(row.id)
                                              "
                                              >{{
                                                $t(
                                                  "views.invest.viewRecentJobs"
                                                )
                                              }}</b-link
                                            >)
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 buttons">
                                          <b-button
                                            :to="'/strategy/' + row.id"
                                            variant="primary"
                                            >{{
                                              $t("views.invest.edit")
                                            }}</b-button
                                          >
                                          <b-button
                                            :disabled="
                                              updatingStrategies.includes(
                                                row.id
                                              )
                                            "
                                            variant="primary"
                                            @click="updateStrategyActive(row)"
                                          >
                                            {{
                                              row.active
                                                ? $t("views.invest.deactivate")
                                                : $t("views.invest.activate")
                                            }}
                                          </b-button>
                                          <b-button
                                            :disabled="
                                              updatingStrategies.includes(
                                                row.id
                                              )
                                            "
                                            @click="deleteStrategy(row.id)"
                                            variant="danger"
                                            >{{
                                              $t("views.invest.delete")
                                            }}</b-button
                                          >
                                          <square-loader
                                            v-if="
                                              updatingStrategies.includes(
                                                row.id
                                              )
                                            "
                                          ></square-loader>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="col-md-7 col-lg-7 col-xl-7 col-sm-12 right-side"
                                    >
                                      <div class="row">
                                        <div class="col-6">
                                          {{
                                            $t(
                                              "views.invest.maximumPortfolioSize"
                                            )
                                          }}
                                        </div>
                                        <div class="col-6 text-right">
                                          {{
                                            row.portfolio_size | moneyFormatter
                                          }}
                                        </div>
                                      </div>
                                      <div
                                        class="row"
                                        v-for="filter in showFilters.filter(
                                          (item) =>
                                            ![31, 23, 26, 21].includes(
                                              item.id
                                            ) &&
                                            item.name_i18n !==
                                              'filters.name.loanId'
                                        )"
                                        v-bind:key="filter.id"
                                      >
                                        <div class="col-4">
                                          {{
                                            filter.name_i18n
                                              ? $t(filter.name_i18n)
                                              : filter.name
                                          }}
                                        </div>
                                        <div class="col-8 text-right">
                                          {{
                                            getFilterValue(
                                              row.loan_filters,
                                              filter
                                            )
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <out-of-loans-modal :enabled="showOutOfLoans" />

      <b-modal centered scrollable v-model="showAutoInvestLogDetails" size="lg">
        <template #modal-header="{ close }">
          <div class="w-100 modal-header-top">
            {{ $t("views.invest.recentAutoinvestJobsHeader") }}
          </div>
          <b-button size="sm" variant="outline" @click="close()">X</b-button>
        </template>
        <div class="w-100">
          <loader v-if="!autoInvestLogJobs"></loader>
          <b-table
            small
            striped
            hover
            sticky-header
            responsive
            v-if="autoInvestLogJobs"
            :fields="autoInvestLogFields"
            :items="autoInvestLogJobs"
          >
            <template v-slot:head()="data">
              <span class="table-header">{{ $t(data.label) }}</span>
            </template>
            <template v-slot:cell(created_at)="{ value }">
              {{ getDateInFormat(value, "DD.MM.YYYY  HH:mm:ss") }}
            </template>
            <template v-slot:cell(result_i18n)="{ value }">
              {{ $t("views.invest.autoinvestlog.messages." + value) }}
            </template>
          </b-table>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import BeforeFormHeader from "../components/BeforeFormHeader";
import investConfig from "../config/invests.json";
import Loader from "../components/Loader";
import InfoBanner from "@/components/InfoBanner";
import moneyMixin from "../mixins/money";
import flagMixin from "../mixins/flag";
import filtersMixin from "../mixins/filters";
import imageMixin from "../mixins/image";
import tempInvestments from "../config/tmp_investments.json";
import FilterBlock from "../components/Filter";
import loans from "@/api/loans";
import classificatorDataHelper from "@/helpers/classificatorDataHelper";
import dateMixin from "../mixins/date";
import loadingMixin from "../mixins/loading";
import apiFilters from "@/api/filters";
import loanOriginatorPageUrl from "@/helpers/loanOriginatorLink";
import Search from "@/components/Search";
import SquareLoader from "@/components/SquareLoader";
import autoinvest from "@/api/autoinvest";
import HelpTooltip from "@/components/HelpTooltip";
import OutOfLoansModal from "../components/OutOfLoansModal";
import localStorageHelper from "@/helpers/localStorageHelper";

export default {
  components: {
    HelpTooltip,
    InfoBanner,
    SquareLoader,
    Search,
    FilterBlock,
    Loader,
    BeforeFormHeader,
    OutOfLoansModal,
  },
  mixins: [
    moneyMixin,
    flagMixin,
    filtersMixin,
    imageMixin,
    dateMixin,
    loadingMixin,
  ],
  data() {
    return {
      investor: null,
      investConfig: investConfig,
      isLoading: true,
      isTableItemsLoading: false,
      isStrategyListLoading: false,
      showOutOfLoans: false,
      tableSteps: [
        {
          id: 1,
          image: "topbriefcase.svg",
          title: "views.invest.manualInvesting",
          description: "views.invest.manualInvestingHelp",
          active: true,
          completed: false,
        },
        {
          id: 2,
          image: "arrows-in-circle.svg",
          title: "views.invest.automatedInvesting",
          description: "views.invest.automatedInvestingHelp",
          active: false,
          completed: false,
        },
      ],
      tableStep: 1,
      tableFields: [
        { key: "country", label: "", class: "table-header", visible: true },
        {
          key: "id",
          label: "views.invest.table.id",
          class: "table-header",
          visible: true,
        },
        {
          key: "originator",
          label: "views.invest.table.originator",
          class: "table-header",
          visible: true,
        },
        {
          key: "loan_investor_interest_rate",
          label: "views.invest.table.interest",
          formatter: "showAsPercentages",
          class: "table-header",
          visible: true,
          sortable: true,
        },
        {
          key: "loan_due_date",
          label: "views.invest.table.remainingTerm",
          class: "table-header",
          sortable: true,
          visible: true,
        },
        {
          key: "loan_buyback_date",
          label: "views.loan-details.buybackDate",
          class: "table-header",
          visible: true,
        },
        {
          key: "loan_currency",
          label: "views.invest.table.loanCurrency",
          class: "table-header",
          visible: true,
        },
        {
          key: "loan_issued_amount_in_eur",
          label: "views.invest.table.loanAmount",
          class: "table-header loan-amount-header",
          visible: true,
        },
        {
          key: "investable_amount",
          label: "views.invest.table.availableAmount",
          class: "table-header",
          sortable: true,
          visible: true,
        },
        {
          key: "loan_status",
          label: "views.invest.table.status",
          class: "table-header",
          visible: true,
        },
        { key: "invest", label: "", class: "table-header", visible: true },
        {
          key: "show_details",
          label: "",
          class: "table-header",
          visible: true,
        },
      ],
      updatingStrategies: [],
      strategies: [],
      totalPortfolioSize: null,
      tableItems: tempInvestments,
      rightPanel: {},
      displayInvest: [],
      invests: [],
      totalRows: 20,
      currentPage: 1,
      loanCount: 0,
      perPage: 20,
      filterName: "",
      filterNameState: null,
      submittedNames: [],
      potentialResultsCount: "-",
      showPotentialCount: false,
      resetFilter: false,
      searchPhrase: "",
      minAmount: investConfig.minLimitAmount,
      showAutoInvestLogDetails: false,
      autoInvestLogJobs: "",
      autoInvestLogFields: [
        {
          key: "created_at",
          label: "views.invest.autoinvestlog.headers.runTime",
          class: "table-header",
        },
        {
          key: "result_i18n",
          label: "views.invest.autoinvestlog.headers.resultMessage",
          class: "table-header",
        },
        {
          key: "invested_loan_count",
          label: "views.invest.autoinvestlog.headers.investedCount",
          class: "table-header",
        },
        {
          key: "invested_amount",
          label: "views.invest.autoinvestlog.headers.investedAmount",
          class: "table-header",
        },
      ],
      advancedShow: false,
    };
  },
  mounted() {
    this.isLoading = !this.loaded;
    let step = this.$route.query.tab;
    // For now actual only 1 and 2 step. 1 is by default
    if (!step || step <= 0 || step > 2) {
      step = 1;
    }
    if (step) {
      this.tableStep = parseInt(step);
    }
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId === "advanced-collapse") {
        this.advancedShow = isJustShown;
      }
    });
  },
  watch: {
    "$store.state.investors.investor": function (investor) {
      if (investor && investor.investor_available_funds) {
        if (
          parseInt(investor.investor_available_funds) <
          investConfig.minLimitAmount
        ) {
          this.minAmount = parseFloat(
            investor.investor_available_funds.toFixed(2)
          );
        }
      }
    },
    "$store.state.filters.enabledFilters": {
      handler(enabledFilters) {
        if (this.$store.state.filters.sendRequest) {
          this.reloadPotentialCount(enabledFilters);
        }
        // console.log('Old reloadPotentialCount run in enabledFilters disabled...', this.$store.state.filters.withoutRequest)
        this.enabledFilters = enabledFilters;
        // this.$refs.invest.refresh()
        // console.log(enabledFilters.length)
        // console.log('Send filters: ', enabledFilters)
      },
      deep: true,
    },
    "$store.state.filters.enabledCustomFilters": {
      handler(enabledCustomFilters) {
        try {
          if (enabledCustomFilters[0] && enabledCustomFilters[0].filters) {
            const customFilters = [...enabledCustomFilters[0].filters];
            const listOfFilters = this.$store.getters[
              "filters/getListOfFilters"
            ](this.$router.currentRoute.path);
            if (listOfFilters) {
              listOfFilters.forEach((filter) => {
                if (filter.type === "range") {
                  const defFilter = {
                    id: filter.id,
                    values: filter.range,
                  };
                  if (
                    customFilters.findIndex((x) => x.id === filter.id) === -1
                  ) {
                    customFilters.push(defFilter);
                  }
                }
              });
            }
            this.reloadPotentialCount(customFilters);
          } else {
            this.reloadPotentialCount([]);
          }
        } catch (e) {
          console.log("Problems with applying of enabled filters ", e);
        }
      },
      deep: true,
    },
    loaded: function () {
      this.isLoading = !this.loaded;
      this.investor = this.$store.state.investors.investor;
      this.enabledFilters = (
        this.$store.state.filters.enabledFilters ?? []
      ).filter((f) => !this.isInDefaultState(f));

      if (this.enabledFilters.length) {
        this.reloadPotentialCount(this.enabledFilters);
      }
    },
    tableStep: {
      handler: function (number) {
        try {
          // Set completed previous steps
          this.tableSteps
            .filter((s) => s.id < number)
            .forEach(function (step) {
              step.active = false;
            });
          // Set not active/completed next elements
          this.tableSteps
            .filter((s) => s.id > number)
            .forEach(function (step) {
              step.active = false;
              step.completed = false;
            });
          // Set active current selected step
          this.tableSteps.filter((s) => s.id === number).shift().active = true;
        } catch (e) {
          console.log("Something went wrong with changing tableSteps", e);
        }

        // Fix for DEV-920 if tab then manual invest else run loadStrategyData
        if (this.$route.query?.tab) {
          this.$nextTick(() => this.loadStrategyData());
        }
      },
      immediate: true,
    },
  },
  methods: {
    loanOriginatorPageUrl,
    setSearch(phrase = "") {
      const dontApply = !this.searchPhrase && !phrase;
      // console.log('Set search(' + this.searchPhrase + ') phrase:', phrase)
      this.searchPhrase = phrase.trim();
      if (!dontApply) {
        this.applyFilters();
      }
    },
    reloadPotentialCount(enabledFilters, emptyFilter = false) {
      if (enabledFilters.length > 0 || emptyFilter === true) {
        this.showPotentialCount = true;
        this.potentialResultsCount = "-";
        loans
          .getLoansCountAfterFilters(enabledFilters ?? [])
          .then((response) => {
            if (response && response.count >= 0) {
              this.potentialResultsCount = parseInt(response.count);
            }
          })
          .catch((error) => {
            this.showPotentialCount = false;
            console.log(error);
          });
      }
    },
    loadInvestData(ctx) {
      let filters = this.$store.state.filters.enabledFilters;
      if (this.resetFilter) {
        filters = [];
        this.resetFilter = false;
      }

      ctx.sortDesc = ctx.sortDesc ? "desc" : "asc";

      // console.log('Send filters:', filters)
      // console.log('this.searchPhrase:', this.searchPhrase)
      const promise = loans.getLoansPage(
        ctx.currentPage,
        filters,
        "",
        this.searchPhrase,
        ctx.sortBy,
        ctx.sortDesc
      );

      return promise
        .then((response) => {
          this.showOutOfLoans = !!response.running_out_of_loans;
          this.totalRows = response.loanCount;
          response.loanList.forEach((loan, index, loanList) => {
            loanList[index].country = classificatorDataHelper.getShortNameById(
              "COUNTRY",
              loan.loan_country_id
            );
            loanList[index].loan_type = classificatorDataHelper.getNameById(
              "LOAN_TYPE",
              loan.loan_type_id
            );
            this.invests[loan.loan_ref] = this.minAmount;
          });
          return this.filterItems(response.loanList);
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    loadStrategyData() {
      this.isStrategyListLoading = true;
      const promise = autoinvest.get();

      return promise
        .then((response) => {
          this.strategies = response.strategies;
          this.showOutOfLoans = !!response.running_out_of_loans;
          this.totalPortfolioSize = response.total_portfolio_size;

          this.isStrategyListLoading = false;
          return this.strategies;
        })
        .catch((error) => {
          this.isStrategyListLoading = false;
          console.log(error);
          return [];
        });
    },
    deleteStrategy(strategyId) {
      this.updatingStrategies.push(strategyId);

      autoinvest
        .deleteStrategy(strategyId)
        .then((response) => {
          let index = this.updatingStrategies.indexOf(strategyId);
          if (index !== -1) {
            this.updatingStrategies.splice(index, 1);
          }

          const strategy = this.strategies.find(
            (strategy) => strategy.id === strategyId
          );
          index = this.strategies.indexOf(strategy);

          if (index !== -1) {
            this.strategies.splice(index, 1);
          }
        })
        .catch((error) => {
          const index = this.updatingStrategies.indexOf(strategyId);
          if (index !== -1) {
            this.updatingStrategies.splice(index, 1);
          }
          console.log(error);
        });
    },
    updateStrategyActive(strategy) {
      this.updatingStrategies.push(strategy.id);

      autoinvest
        .activateStrategy(strategy.id, {
          active: !strategy.active,
        })
        .then((response) => {
          let index = this.updatingStrategies.indexOf(strategy.id);
          if (index !== -1) {
            this.updatingStrategies.splice(index, 1);
          }

          index = this.strategies.indexOf(strategy);

          if (index !== -1) {
            this.strategies[index].active = response.active;
          }
        })
        .catch((error) => {
          const index = this.updatingStrategies.indexOf(strategy.id);
          if (index !== -1) {
            this.updatingStrategies.splice(index, 1);
          }
          console.log(error);
          return [];
        });
    },
    setTableStep(number) {
      if (this.tableStep !== number) {
        if (number !== 1) {
          this.$router.push({ path: this.$route.path, query: { tab: number } });
        } else {
          this.$router.push({ path: this.$route.path });
        }
      }
      this.tableStep = number;
    },
    setTableItemsLoading(state) {
      this.isTableItemsLoading = state;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showInvestInput(itemId) {
      this.displayInvest.push(itemId);
      this.$nextTick(() => this.$refs[itemId].focus());
    },
    showInvestButton(itemID) {
      return !this.displayInvest.includes(itemID);
    },
    removeDisplayInvest(itemId) {
      this.displayInvest = this.displayInvest.filter((item) => item !== itemId);
    },
    addInvest(item) {
      const amount = this.$refs[item.loan_ref].$el.value;
      if (item.loan_ref && amount) {
        if (this.validate(amount, item.loan_ref, item.investable_amount)) {
          item.amount = amount;
          this.$store.dispatch("invests/addInvestItem", item);
          this.removeDisplayInvest(item.loan_ref);
          this.scrollToTop();
          this.showModal();
        }
      }
    },
    showModal() {
      this.$refs["next-step"].show();
    },
    hideModal() {
      this.$refs["next-step"].hide();
    },
    validate(event, itemId, maxInvestableAmount) {
      const maxInvestAmount = parseFloat(maxInvestableAmount);
      if (
        !event ||
        event < this.minAmount ||
        event > maxInvestAmount ||
        (maxInvestAmount <= 1 && parseFloat(event) !== maxInvestAmount)
      ) {
        this.$refs[itemId].$el.classList.add("invalid");
        return false;
      } else {
        this.$refs[itemId].$el.classList.remove("invalid");
        return true;
      }
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.filterNameState = valid;
      return valid;
    },
    resetModal() {
      this.filterName = "";
      this.filterNameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      const filterData = {
        name: this.filterName,
        filters: this.enabledFilters,
      };
      apiFilters.set(filterData).then((response) => {
        const newFilter = {
          filters: filterData.filters,
          id: response.id,
          name: filterData.name,
        };
        this.$store.dispatch("filters/addUserFilter", newFilter);
        const filters = localStorageHelper.getJson("filters");
        if (filters && filters.user_filters) {
          filters.user_filters.push(newFilter);
          localStorageHelper.setAsJson("filters", filters);
        }
      }, this);
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    resetFilters() {
      this.$store.dispatch("filters/updateSendRequest", false);
      this.resetFilter = true;
      this.$root.$emit("resetInvestFilters");
      this.applyFilters();
      this.enabledFilters = this.$store.getters["filters/getEnabledFilters"];
      this.reloadPotentialCount(this.enabledFilters, true);
      // console.log('TODO RESET FILTERS')
    },
    applyFilters() {
      this.currentPage = 1;
      this.$refs.invest.refresh();
      window.scrollTo(0, 0);
    },
    getFilterValue(strategyFilters, originalFilter) {
      const filter = strategyFilters.find(
        (filter) => parseInt(filter.id) === parseInt(originalFilter.id)
      );
      return this.formatFilterValue(filter?.values, originalFilter);
    },
    formatFilterValue(values, originalFilter) {
      if (originalFilter.type === "range") {
        let min =
          values !== undefined ? Math.min(...values) : originalFilter.min;
        let max =
          values !== undefined ? Math.max(...values) : originalFilter.max;

        if (originalFilter.money) {
          min = this.$options.filters.moneyFormatter(min);
          max = this.$options.filters.moneyFormatter(max);
        }

        return (
          min +
          (originalFilter.label.start ?? "") +
          " " +
          this.$t("views.invest.to") +
          " " +
          max +
          (originalFilter.label.end ?? "")
        );
      }
      if (originalFilter.type === "multiselect") {
        if (values) {
          return values.map((x) => x.name).join(", ");
        }
        return "ALL";
      }
      if (originalFilter.type === "boolean") {
        return values === true
          ? this.$t("investorprofile.yes")
          : this.$t("investorprofile.no");
      }
      return "";
    },
    getDefaultFilterValue(filter) {
      return this.enabledFilters.find((f) => f.id === filter.id)?.values;
    },
    isInDefaultState(filter) {
      const defaultFilter = this.$store.state.filters.filters.filters.find(
        (x) => x.id === filter.id
      );
      if (["multiselect", "boolean"].includes(defaultFilter.type)) {
        return !filter.values.length;
      }
      if (["range"].includes(defaultFilter.type)) {
        return (
          filter.values.length === defaultFilter.range.length &&
          filter.values.every(
            (value, index) => value === defaultFilter.range[index]
          )
        );
      }
      return false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getMinAmount(maxInvestableAmount) {
      const investableAmount = parseFloat(maxInvestableAmount);
      const minAmount = parseFloat(this.minAmount);
      return (investableAmount > 1 ? minAmount : investableAmount).toFixed(2);
    },
    maxRound(currentValue, maxValue, refId) {
      const diff = maxValue - currentValue;
      if (diff < 1) {
        // console.log('DIFF:', diff, ' SET to ', maxValue, ' refId ', refId, ' Prev value', this.$refs[refId].$el.value)
        this.$refs[refId].$el.value = maxValue;
      }
    },
    loadRecentAutoinvestJobs(id) {
      this.autoInvestLogJobs = null;
      const promise = autoinvest.getRecentJobs(id);
      promise
        .then((response) => {
          this.autoInvestLogJobs = response;
        })
        .catch((error) => {
          this.autoInvestLogJobs = error;
          console.log(error);
        });
      this.showAutoInvestLogDetails = true;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.invest {
  .income-tabs-list {
    .nav {
      &-item {
        a {
          @media (max-width: 480px) {
            width: 100%;
          }
        }

        @media (max-width: 480px) {
          margin: 0;
        }
      }

      @media (max-width: 480px) {
        flex-direction: column;
      }
    }

    .income-tabs {
      @media (max-width: 480px) {
        width: 100%;
      }
    }
  }
}

.redesign-invest {
  td[role="cell"] {
    padding: 4px 0 4px 4px !important;
  }
  th:first-child {
    padding: 4px 0 4px 7px !important;
  }
  .small-header {
    max-width: 87px;
  }
}

.filter-by-type {
  margin: 5px 0 !important;
  float: right;
  max-width: 295px;
}

.custom-filters .active-filter {
  label {
    background: #30a7fe !important;

    .delete-filter {
      color: #ffffff !important;
    }
  }
}

.loan-amount-header {
  //min-width: 150px !important;
}

//.invest-table th, .invest-table td {
//  padding: 0.27rem !important;
//}
//
//.invest-table td,
//.invest-table thead th {
//  max-width: 75px;
//}

.multiselect__tags-wrap .multiselect__tag {
  background: #30a7fe !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #30a7fe !important;
  background-color: #30a7fe !important;
}
</style>
<style lang="scss" scoped>
.invest-section {
  overflow: hidden;
}

.autoinvest-strategy-column {
  padding: 0px;
}

.filter {
  border-bottom: 1px solid #e5e9ed;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #000000;
    margin-bottom: 16px;
    margin-top: 15px;
  }

  .dots {
    float: right;
  }

  hr {
    background: #e5e9ed;
  }
}

.right-col {
  background: #ffffff;
  border-radius: 4px;
  min-height: 359px;
  text-align: center;

  .bottom-note {
    display: inline-block;
  }
}
[lang="et"] {
  .potential-count {
    font-size: 14px;
  }
  .create-strategy {
    padding-left: 0;
    padding-right: 0;
    padding-top: 5px;
  }
  .apply-filter,
  .set-favorite-filter,
  .create-strategy {
    width: 100%;
  }
}
[lang="en"] {
  .create-strategy {
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
    width: 100%;
  }
  .set-favorite-filter {
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
    width: 45%;
  }
  .apply-filter {
    width: 50%;
  }
}
.right-filters {
  //background: #f5fbff;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: left;
  padding-top: 5px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #000000;
  }

  .value {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }
}

.small-stepper {
  font-weight: bold;
  line-height: 20px;
  margin: 20px auto 0 3px;
}

.description {
  font-size: 13px;
  color: #6e777a;
}

//.invest-table {
//  margin-top: 20px;
//  font-size: 11px !important;
//}

.flag {
  width: 16px;
}

//.table-header {
//  font-style: normal;
//  font-weight: bold;
//  font-size: 8px;
//  line-height: 10px;
//  text-align: center;
//  text-transform: uppercase;
//  color: #9DA0A6;
//}

.toggle-details-btn {
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  color: #9da0a6;
  background-color: transparent;
  border: none;
}

.invest-btn {
  background-color: #30a7fe !important;
  border: 2px solid #30a7fe;
  box-sizing: border-box;
  border-radius: 14px;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  mix-blend-mode: normal;
  opacity: 0.8;
  margin-right: 3px;
  min-width: 125px;
}

.end-range-title {
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #000000;
}

.start-range-title {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
}

// Remove autofill bg!
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s !important;
}

.invest-ig {
  border: 1px solid #e2f3ff;
  border-radius: 16px;
  padding: 2px;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  //margin: 15px 2px 2px;
  /*background: #E2F3FF;*/
  font-size: 19px;
  min-width: 125px;
  height: 42px;
  /*box-shadow: 1px 3px 16px 0 var(--blue-income-50);*/

  .prepend {
    margin-left: 10px;
    padding-top: 8px;
    color: var(--blue-income);
  }

  .invest-input,
  .invest-input:focus,
  .invest-input:hover {
    border: none;
    border-radius: 0;
    background: transparent;
    outline: 0;
    box-shadow: none;
    font-size: 19px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 10px;
  }

  .append {
    float: right;
    cursor: pointer;
    margin-right: 8px;
    margin-top: 10px;

    img {
      height: 19px;
    }
  }
}

.remove-invest {
  background: transparent;
  border: none;
  float: right;
  cursor: pointer;
  padding: 1px;
}

.invest-form {
  display: inline-flex;

  .invalid {
    color: red;
    font-weight: bold;
  }
}

.loan-details {
  float: right;
  background: #30a7fe;
  border-radius: 14px;
  border-color: transparent;
  font-size: 11px;
}

.set-favorite-filter,
.create-strategy {
  border: 2px solid #30a7fe;
  box-sizing: border-box;
  border-radius: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 20px;
  color: #000000;
  float: right;
  margin: 2px;
  background: transparent;
}

.reset-filter {
  width: 45%;
  button {
    padding: 5px;
  }
  margin-bottom: 5px;
}

.top-btns {
  display: inline-block;

  .clear-filter {
    border: none;
    box-sizing: border-box;
    border-radius: 50px;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: #000000;
    float: right;
    margin: 5px;
    background: transparent;
    box-shadow: none;

    img {
      max-width: 25px;
    }
  }
}

.set-filter-block {
  margin-top: 5px;
  float: right;
}

.apply-filter {
  background: #30a7fe;
  border: 1px solid #30a7fe;
  color: white;
  border-radius: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 20px;
  margin: 2px;
  box-shadow: none;
}

.advancedBtn,
.advancedBtn:hover,
.advancedBtn:focus {
  margin-top: 10px;
  font-weight: bold;
  color: #30a7fe !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 14px;
  padding-left: 0;
}

.potential-count {
  font-style: normal;
  //font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.02em;
  display: inline-block;
  padding-top: 10px;
  padding-left: 5px;

  .count {
    font-size: 18px;
    font-weight: bold;
  }
}

.your {
  box-shadow: 0 1px 6px rgba(49, 166, 251, 0.35);
  border-radius: 10px;
  padding: 10px;
}

.top {
  margin-top: 5px;
}

.header-description {
  color: #c3c3c3;
  font-size: 14px;
}

.overview {
  margin-bottom: 45px;
  margin-left: 5px;
  font-size: 13px;

  .header,
  .header-value {
    font-size: 24px;
    font-weight: bold;
  }

  .header0 {
    font-size: 14px;
    font-weight: bold;
  }

  .total {
    font-weight: bold;
  }

  .info-table {
    padding: 10px;
    .right-side div,
    .left-side div {
      margin-bottom: 5px;
    }

    @media (min-width: 768px) {
      .right-side {
        border-left: 2px dotted #b1c2cf;
      }
    }

    img {
      min-height: 11px;
    }
  }

  & > .row {
    margin-bottom: 10px;
  }
}

.invest-stat-top {
  display: flex;
  align-items: center;
  @media (max-width: 998px) {
    display: block;
    width: 100%;
    .flex-1,
    .center {
      // display: block;
    }
    .create {
      display: block;
      width: 100%;
      .btn {
        display: block;
        width: 100%;
      }
    }
  }
}

.buttons {
  display: flex;
  align-items: center;
  margin-top: 10px;

  @media (max-width: 998px) {
    display: block;
    width: 100%;
    margin-left: 0px;
    .btn {
      margin-left: 0px;
      width: 100%;
      margin-bottom: 5px;
    }
  }

  *:first-child {
    margin-left: 0px;
  }

  * {
    margin-left: 10px;
  }
}

.confirm-btn {
  background-color: #30a7fe !important;
  border-color: #30a7f1 !important;
}

.center {
  display: flex;
  align-items: center;
}

.flex-1 {
  flex: 1 1 0%;
}

.top-row {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 575px) {
  .modal-fix {
    width: calc(100% - 45px);
    margin-left: 20px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
